import { Tabs as MuiTabs, styled } from '@mui/material'

const StyledTabs = styled(MuiTabs)(({ theme }) => ({
    root: {
        flexGrow: 1,
        borderRadius: '5px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
        display: 'flex',
        minHeight: '40px',
    },
    flexContainer: {
        flexDirection: 'column',
    },
    indicator: {
        backgroundColor: '#0057A0',
        left: 0,
    },
}))

export default StyledTabs
